// 权限控制（参考：https://forum.vuejs.org/t/vue2-0/28657）

import router from './router/router'
import store from './store'
import Storage from './utils/storage'
import NProgress from 'nprogress' // progress bar
import { Message } from 'element-ui'


// NProgress.configure({ showSpinner: false })// NProgress Configuration

// permission judge function
// function hasPermission(roles, permissionRoles) {
//     if (roles.indexOf('admin') >= 0) return true // admin permission passed directly
//     if (!permissionRoles) return true
//     return roles.some(role => permissionRoles.indexOf(role) >= 0)
// }

function getToken() {
    let token = Storage.get('token')
    if (token) {
        return true;
    }else {
        return false
    }
}

function GetProjectInfo() {
    let ProjectInfo = Storage.get('ProjectInfo')
    if (ProjectInfo) {
        return ProjectInfo.projectInfo;
    } else {
        return false
    }
}

const whiteList = ['/login']// no redirect whitelist

router.beforeEach((to, from, next) => {
    NProgress.start() // start progress bar
    if (getToken()) { // determine if there has token
        /* has token */
        if (to.path === '/login') {
            localStorage.clear();   //  防止token未过期，路由重复添加
            next()
            NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
        } else {
            /* *****************   has userInfo  ************** */
            if (!store.getters.user.username) { // 判断当前用户是否已拉取完user_info信息
                store.dispatch('GetUserInfo').then(res => { // 拉取user_info
                    const usertype = res.usertype // Usertype:1/2/3/4   四类账号
                    store.dispatch('GenerateRoutes', usertype).then((addRouters) => { // 根据用户信息权限生成可访问的路由表
                        router.addRoutes(addRouters) // 动态添加可访问路由表
                        next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                    })
                }).catch((err) => {
                    // 返回登录页面
                    Message.error(err)
                    next({ path: '/login' })
                })
            } else {
                // 判断是否是admin
                if(to.meta.role === "admin"){
                    if (store.getters.user.usertype === 1) {
                        next()
                    }else{
                        next({ path: '/401', replace: true, query: { noGoBack: true } })
                    }
                }else{
                    // 判断访问路由跟系统类型关系
                    if (GetProjectInfo()) {
                        if (!to.meta.system && GetProjectInfo().sysid === 1) {
                            // 机房系统
                            Storage.remove("OID");
                            Storage.remove("ProjectInfo");
                            next()
                        }
                    }
                    next()
                }
               
                // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
               
                // if (hasPermission(store.getters.roles, to.meta.roles)) {
                //     next()
                // } else {
                //     next({ path: '/401', replace: true, query: { noGoBack: true } })
                // }
                // 可删 ↑
            }
        }
    } else {
        /* has no token*/
        if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
            next()
        } else {
            location.href = `/login?redirect=${to.path}`
            // next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
        }
        NProgress.done()
    }
})

router.afterEach(() => {
    NProgress.done() // finish progress bar
})
